import React, { useContext } from 'react';
import PocketBase from 'pocketbase';

// URL'i almak için helper fonksiyon
const getPocketBaseUrl = () => {
  // window._env_ tanımlı değilse veya REACT_APP_POCKETBASE_URL undefined ise default değeri kullan
  // Development için localhost kullan, production için domain
  const isDevelopment = process.env.NODE_ENV === 'development';
  const defaultUrl = isDevelopment ? 'http://localhost:8090' : 'https://pocketbase.reformyangin.com';
  return window._env_?.REACT_APP_POCKETBASE_URL ?? defaultUrl;
}

// PocketBase instance'ı oluştur
const pb = new PocketBase(getPocketBaseUrl());

// Context oluştur
export const PocketBaseContext = React.createContext(null);

// Provider component
export const PocketBaseProvider = ({ children }) => {
  // Değer değişmeyeceği için useMemo kullanmaya gerek yok
  return (
    <PocketBaseContext.Provider value={pb}>
      {children}
    </PocketBaseContext.Provider>
  );
};

// Custom hook
export const usePocketBase = () => {
  const context = useContext(PocketBaseContext);
  if (!context) {
    throw new Error('usePocketBase must be used within a PocketBaseProvider');
  }
  return context;
};

// PocketBase instance'ını da export et
export { pb };